/**
 * upload接口配置
 */
import type { ApiEndpoint } from '../types';
import { API_CATEGORIES } from '../constants';

export const uploadEndpoints: ApiEndpoint[] = [
  {
    id: 'upload-single',
    method: 'POST',
    path: '/api/upload/single',
    name: '单文件上传',
    description: '上传单个文件',
    category: API_CATEGORIES.UPLOAD,
    bodyParams: [
      { name: 'file', type: 'file', required: true, description: '上传的文件（multipart/form-data）' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'object', description: '文件信息' },
      { name: 'message', type: 'string', description: '响应消息' }
    ]
  },
  {
    id: 'upload-multiple',
    method: 'POST',
    path: '/api/upload/multiple',
    name: '多文件上传',
    description: '上传多个文件（最多10个）',
    category: API_CATEGORIES.UPLOAD,
    bodyParams: [
      { name: 'files', type: 'file[]', required: true, description: '上传的文件数组（multipart/form-data）' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'array', description: '上传的文件信息列表' },
      { name: 'message', type: 'string', description: '响应消息' }
    ]
  },
  {
    id: 'upload-image',
    method: 'POST',
    path: '/api/upload/image',
    name: '图片上传',
    description: '上传图片文件',
    category: API_CATEGORIES.UPLOAD,
    bodyParams: [
      { name: 'image', type: 'file', required: true, description: '上传的图片（multipart/form-data）' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'object', description: '图片信息' },
      { name: 'message', type: 'string', description: '响应消息' }
    ]
  },
  {
    id: 'upload-drawing',
    method: 'POST',
    path: '/api/upload/drawing',
    name: '图纸上传',
    description: '上传图纸文件',
    category: API_CATEGORIES.UPLOAD,
    bodyParams: [
      { name: 'drawing', type: 'file', required: true, description: '上传的图纸（multipart/form-data）' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'object', description: '图纸信息' },
      { name: 'message', type: 'string', description: '响应消息' }
    ],
    requiredPermission: 'msspace:upload:view'
  },
  {
    id: 'upload-3d-model',
    method: 'POST',
    path: '/api/upload/3d-model',
    name: '3D模型上传',
    description: '上传3D模型文件',
    category: API_CATEGORIES.UPLOAD,
    bodyParams: [
      { name: 'model', type: 'file', required: true, description: '上传的3D模型（multipart/form-data）' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'object', description: '模型信息' },
      { name: 'message', type: 'string', description: '响应消息' }
    ],
    requiredPermission: 'msspace:upload:view'
  },
  {
    id: 'upload-file-info',
    method: 'GET',
    path: '/api/upload/file/:filename',
    name: '获取文件信息',
    description: '根据文件名获取文件信息',
    category: API_CATEGORIES.UPLOAD,
    pathParams: [
      { name: 'filename', type: 'string', required: true, description: '文件名' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'object', description: '文件信息' }
    ]
  },
];
